import { BaseComponent } from './../../../../core/abstracts/baseComponent';
import { BenefitsState } from './../../../../core/store/benefits/benefits.reducer';
import { BenefitPlanModel } from './../../../../models/benefitsModels';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { Component, OnInit, signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { Actions, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { MultiSelect } from 'primeng/multiselect';
import { AlertService } from '../../../../shared/services/alert.service';
import { deepClone, downloadFile, getShortDateFormatted, getTimeStampString } from '../../../../helpers/utils';
import { deleteBenefitsPlans, deleteBenefitsPlansSuccess, downloadEnrollmentSignedForms, downloadEnrollmentSignedFormsSuccess, exportAllDentalSelectEnrollmentListToExcel, exportAllDentalSelectEnrollmentListToExcelSuccess, exportEnrollmentListToExcel, exportEnrollmentListToExcelSuccess, loadBenefitsPlans, showEditBenefitsSettings, showEditHelpInformation } from '../../../../core/store/benefits/benefits.actions';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { tap } from 'rxjs';
import { DateRangeModel } from '../../../../models/dateRangeModel';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';

@Component({
    selector: 'app-list-benefits-plans',
    templateUrl: './list-benefits-plans.component.html',
    styleUrls: ['./list-benefits-plans.component.scss'],
    standalone: false
})
export class ListBenefitsPlansComponent extends BaseComponent implements OnInit {

  benefitPlanList: PagingResultsModel<BenefitPlanModel>;
  canEdit: boolean;
  canEditOpenEnrollment: boolean;
  loadingBenefitPlanList = false;
  loadingExcelDownload = false;
  downloadingZipFile = false;
  filter: any;
  yesNoAllOptions = [
    { label: 'All', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];
  datesOptions = [
    { label: 'This Year', value: 1 },
    { label: 'Last Year', value: 2 },
    { label: 'Next Year', value: 3 },
    { label: 'Custom', value: 0 },
  ];

  planNameFilter;
  carrierFilter;
  periodDateFilter;
  periodDateOptionFilter;
  activeFilter = true;

  excelDownloadName: string = "BenefitEnrollment";
  zipDownloadCarrier: string = "ZipFile";

  dateEnrolledOptionList: DateRangeModel[];
  dateEnrolledRange: DateRangeModel;
  dateActivatedStart: string = null;
  dateActivatedEnd: string = null;
  isCustomDateEnrolled: boolean = false;
  dateEnrolledCustomFilter;
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private store: Store<State>,
    private router: Router,
    private confirmationService: ConfirmationService,
    private dropdownFilterService: DropdownFilterService
  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 6050);
        this.canEditOpenEnrollment = permissionIDs && !!permissionIDs.find(p => p === 3141)
      }),
      this.store.select(s => s.benefitsState.benefitPlanList).subscribe(benefitPlanList => {
        if (benefitPlanList) {
          this.benefitPlanList = benefitPlanList;
          this.totalRecords.set(benefitPlanList.totalRecords);

        }
      }),

      this.store.select(s => s.benefitsState.loadingBenefitPlanList).subscribe(loadingBenefitPlanList => {
        this.loadingBenefitPlanList = loadingBenefitPlanList;
      }),
      this.store.select(s => s.benefitsState.loadingEnrollmentsExcel).subscribe(loadingExcelDownload => {
        this.loadingExcelDownload = loadingExcelDownload;
      }),
      this.store.select(s => s.benefitsState.downloadingSignedDocumentsZipFile).subscribe(downloadingZipFile => {
        this.downloadingZipFile = downloadingZipFile;
      }),
      this.actions$.pipe(
        ofType(deleteBenefitsPlansSuccess),
        tap(action => {
          this.loadPage(this.filter);
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(exportEnrollmentListToExcelSuccess),
        tap(action => {
          downloadFile(action.doc, this.getExcelFileName());
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(exportAllDentalSelectEnrollmentListToExcelSuccess),
        tap(action => {
          downloadFile(action.doc, this.getExcelFileName());
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(downloadEnrollmentSignedFormsSuccess),
        tap(action => {
          downloadFile(action.doc, this.getZipFileName());
        })
      ).subscribe()
    );

    this.dateEnrolledOptionList = this.dropdownFilterService.getWeekMonthAllDateRanges();
    if (this.dateEnrolledOptionList && this.dateEnrolledOptionList.length > 0) {
      this.dateEnrolledRange = this.dateEnrolledOptionList[0];
    }
  }

  getZipFileName() {
    let fileName = this.zipDownloadCarrier + "_" + getTimeStampString() + ".zip";

    return fileName;
  }

  getExcelFileName() {
    let fileName = this.excelDownloadName;
    
    fileName += getTimeStampString();
    fileName += ".xlsx"

    return fileName;
  }

  loadPage(event) {
    if (!this.loadingBenefitPlanList) {
      this.loadingBenefitPlanList = true;
      this.filter = deepClone(event);
      this.filter.filters.planNameFilter = { Name: 'planNameFilter', Value: { value: this.planNameFilter } };
      this.filter.filters.carrierFilter = { Name: 'carrierFilter', Value: { value: this.carrierFilter } };
      this.filter.filters.activeFilter = { Name: 'activeFilter', Value: { value: this.activeFilter } };
      if (this.periodDateOptionFilter > 0) {
        let year = new Date().getFullYear();
        if (this.periodDateOptionFilter === 2) {
          year = year - 1;
        }
        if (this.periodDateOptionFilter === 3) {
          year = year + 1;
        }
        const start = new Date(year, 0, 1);
        const end = new Date(year, 11, 31);
        this.filter.filters.createdDateFilterStart = { Name: 'createdDateFilterStart', Value: { value: start.toISOString() } };
        this.filter.filters.createdDateFilterEnd = { Name: 'createdDateFilterEnd', Value: { value: end.toISOString() } };
      } else {
        if (this.periodDateFilter) {
          this.filter.filters.createdDateFilterStart = { Name: 'createdDateFilterStart', Value: { value: this.periodDateFilter[0] } };
          this.filter.filters.createdDateFilterEnd = { Name: 'createdDateFilterEnd', Value: { value: this.periodDateFilter[1] } };
        } else {
          this.filter.filters.createdDateFilterStart = { Name: 'createdDateFilterStart', Value: { value: null } };
          this.filter.filters.createdDateFilterEnd = { Name: 'createdDateFilterEnd', Value: { value: null } };
        }
      }

      this.filter.filters.dateActivatedStart = { Name: 'dateActivatedStart', Value: { value: this.dateActivatedStart } };
      this.filter.filters.dateActivatedEnd = { Name: 'dateActivatedEnd', Value: { value: this.dateActivatedEnd } };

      this.store.dispatch(loadBenefitsPlans({
        filter: deepClone(this.filter)
      }));
    }
  }

  changedDateEnrolledCustomFilter() {
    if (this.dateEnrolledCustomFilter) {
      this.dateActivatedStart = this.dateEnrolledCustomFilter[0];
      this.dateActivatedEnd = this.dateEnrolledCustomFilter[1];
    }
    else {
      this.dateActivatedStart = null;
      this.dateActivatedEnd = null;
    }

    this.changedFilters();
  }

  changedEnrolledDateRange() {
    if (this.dateEnrolledRange.isCustom) {
      this.isCustomDateEnrolled = true;
      return; //reload after manually changing date
    }

    this.isCustomDateEnrolled = false;
    this.dateActivatedStart = this.dateEnrolledRange.startDate;
    this.dateActivatedEnd = this.dateEnrolledRange.endDate;
    this.changedFilters();
  }

  changedFilters() {
    this.loadPage(this.filter);
  }


  editBenefitsPlan(benefitPlan: BenefitPlanModel) {
    this.router.navigate(['/benefits-management/benefit-plan/addit/' + benefitPlan.id]);
  }

  deleteBenefitsPlan(benefitPlan: BenefitPlanModel) {
    this.confirmationService.confirm({
      header: 'Delete',
      message: 'Are you sure you want to deactivate this plan?',
      acceptLabel: 'Deactivate',
      rejectLabel: 'Cancel',
      accept: () => {
        this.store.dispatch(deleteBenefitsPlans({ benefitsPlanID: benefitPlan.id }));
      }
    });
  }

  downloadSignDocumentZipFile(benefitPlan: BenefitPlanModel) {
    if (this.downloadingZipFile) {
      return;
    }

    this.zipDownloadCarrier = benefitPlan.carrier;

    this.store.dispatch(downloadEnrollmentSignedForms({ benefitPlanId: benefitPlan.id }));
  }

  exportEnrollments(benefitPlan: BenefitPlanModel) {
    if (this.loadingExcelDownload) {
      return;
    }

    this.excelDownloadName = benefitPlan.planName.replace(/([\W])/ig,'_');
    let exportFilter:any = {};
    exportFilter.filters = {};
    exportFilter.filters.planId = { Name: 'planId', Value: { value: benefitPlan.id.toString() } };
    exportFilter.filters.dateActivatedStart = { Name: 'dateActivatedStart', Value: { value: this.dateActivatedStart } };
    exportFilter.filters.dateActivatedEnd = { Name: 'dateActivatedEnd', Value: { value: this.dateActivatedEnd } };


    this.store.dispatch(exportEnrollmentListToExcel({ filter: exportFilter }));
  }
  

  showExport(benefitPlan: BenefitPlanModel) {
    if (this.canEdit == false) {
      return false;
    }

    return benefitPlan.enrolledEmployees > 0;
  }
  
  openMultiSelect(multiselect: MultiSelect) {
    multiselect.show();
  }

  editBenefitSettings() {
    this.store.dispatch(showEditBenefitsSettings());
  }

  editEnrollmentHelpInformation() {
    this.store.dispatch(showEditHelpInformation());
  }

  getPeriod(benefitPlan: BenefitPlanModel) {
    //               {{employeeWithBenefits.enrollmentSet?.activatedDate | date:'shortDate' }}
    
    let dateStart = new Date(benefitPlan.dateStart);
    let dateEnd = new Date(benefitPlan.dateEnd);

    var p = '-';
    if (!benefitPlan.dateEnd && !benefitPlan.dateStart)
      return '-';


    if (benefitPlan.dateStart && dateStart.getMonth() == 0 && dateStart.getDate() == 1)
      p = dateStart.getFullYear().toString()
    else if (benefitPlan.dateStart)
      p = getShortDateFormatted(dateStart)
    else
      p = 'End';

    if (!benefitPlan.dateEnd)
      return 'Start' + p;


    if (dateEnd.getMonth() == 11 && dateEnd.getDate() == 31)
    {
      if (benefitPlan.dateStart && dateStart.getFullYear() == dateEnd.getFullYear() && dateStart.getMonth() == 0 && dateStart.getDate() == 1)
        return p;
      return `${p} - ${dateEnd.getFullYear() }`;  
    }

    if (benefitPlan.dateStart && dateEnd == dateStart)
      return p;

    return `${p} - ${getShortDateFormatted(dateEnd)}`;  

  }

}

